var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadImage',{staticClass:"system-avatar",attrs:{"src":_vm.imageUrl,"width":"500","height":"500","alt":"キャリアマップ事務局のロゴ","valiantName":[{'-is-rounded': _vm.isRounded, '-is-circle': _vm.isCircle}]}})}
var staticRenderFns = []

export { render, staticRenderFns }